import React from 'react';
import useAppContext from 'flow/hooks/useAppContext';
import BaseModal from 'flow/components/ui-components/BaseModal';
import Loading from '../ui-components/Loading';
import { SourceType } from 'flow/types/region-lookup/LoginData';

export interface CancelExternalSignInDialogProps {
    open: boolean;
    onClose: () => void;
    syncSource: SourceType;
}

const CancelExternalSignInDialog: React.FC<CancelExternalSignInDialogProps> = ({
    open,
    onClose,
    syncSource,
}) => {
    const { i18next } = useAppContext();
    const waitingText = i18next.t(`signin.${syncSource}.waiting`);

    return (
        <BaseModal open={open} onClose={onClose} ariaLabel={waitingText}>
            <div className="flex min-h-[260px] min-w-[280px] flex-col items-center justify-center p-6">
                <div className="my-5">
                    <Loading />
                </div>
                <div className="my-5 text-center">{waitingText}</div>
            </div>
        </BaseModal>
    );
};

export default React.memo(CancelExternalSignInDialog);
